{
  "id": "munich",
  "makes": ["BMW", "BMW M", "MINI", "BMW Motorrad"],
  "mainGroups": "bmw",
  "sources": "Built-in chassis codes compiled in October 2026 from Wikipedia's BMW and BMW M model lists and generation pages (body sub-codes), MotoringFile's MINI code table and the RealOEM/bimmerarchiv parts catalogue data for BMW Motorrad; codes no source confirmed are left out (e.g. F81 was never built). Each code means one model: M cars, electric twins and motorcycles that share a code with another model carry their model in brackets, so no code appears in two lists.",
  "chassisCodeLists": [
    {
      "id": "bmw",
      "aliases": true,
      "entries": [
        {
          "code": "E3",
          "model": { "en": "New Six saloon (2500–3.3)", "de": "Große Limousine (2500–3.3)" },
          "from": 1968,
          "to": 1977
        },
        {
          "code": "E9",
          "model": {
            "en": "New Six coupé (2800 CS–3.0 CSL)",
            "de": "Großes Coupé (2800 CS–3.0 CSL)"
          },
          "from": 1968,
          "to": 1975
        },
        {
          "code": "E10",
          "model": { "en": "02 Series (1602–2002)", "de": "02er (1602–2002)" },
          "from": 1966,
          "to": 1977
        },
        { "code": "E12", "model": { "en": "5 Series", "de": "5er" }, "from": 1972, "to": 1981 },
        { "code": "E21", "model": { "en": "3 Series", "de": "3er" }, "from": 1975, "to": 1983 },
        { "code": "E23", "model": { "en": "7 Series", "de": "7er" }, "from": 1977, "to": 1987 },
        { "code": "E24", "model": { "en": "6 Series", "de": "6er" }, "from": 1976, "to": 1989 },
        { "code": "E28", "model": { "en": "5 Series", "de": "5er" }, "from": 1981, "to": 1988 },
        {
          "code": "E30",
          "model": { "en": "3 Series (all bodies)", "de": "3er (alle Karosserien)" },
          "from": 1982,
          "to": 1994
        },
        {
          "code": "E30/2",
          "model": { "en": "3 Series 2-door Saloon", "de": "3er Zweitürer" },
          "from": 1982,
          "to": 1991,
          "parent": "E30"
        },
        {
          "code": "E30/2C",
          "model": { "en": "3 Series Convertible", "de": "3er Cabrio" },
          "from": 1985,
          "to": 1993,
          "parent": "E30"
        },
        {
          "code": "E30/4",
          "model": { "en": "3 Series 4-door Saloon", "de": "3er Viertürer" },
          "from": 1983,
          "to": 1992,
          "parent": "E30"
        },
        {
          "code": "E30/5",
          "model": { "en": "3 Series Touring", "de": "3er Touring" },
          "from": 1987,
          "to": 1994,
          "parent": "E30"
        },
        {
          "code": "E30/16",
          "model": { "en": "325iX (all-wheel drive)", "de": "325iX (Allrad)" },
          "from": 1985,
          "to": 1991,
          "parent": "E30"
        },
        { "code": "E31", "model": { "en": "8 Series", "de": "8er" }, "from": 1989, "to": 1999 },
        { "code": "E32", "model": { "en": "7 Series", "de": "7er" }, "from": 1986, "to": 1994 },
        { "code": "E34", "model": { "en": "5 Series", "de": "5er" }, "from": 1987, "to": 1996 },
        {
          "code": "E36",
          "model": { "en": "3 Series (all bodies)", "de": "3er (alle Karosserien)" },
          "from": 1990,
          "to": 2000
        },
        {
          "code": "E36/2",
          "model": { "en": "3 Series Coupé", "de": "3er Coupé" },
          "from": 1992,
          "to": 1999,
          "parent": "E36"
        },
        {
          "code": "E36/2C",
          "model": { "en": "3 Series Convertible", "de": "3er Cabrio" },
          "from": 1993,
          "to": 1999,
          "parent": "E36"
        },
        {
          "code": "E36/3",
          "model": { "en": "3 Series Touring", "de": "3er Touring" },
          "from": 1995,
          "to": 1999,
          "parent": "E36"
        },
        {
          "code": "E36/4",
          "model": { "en": "3 Series Saloon", "de": "3er Limousine" },
          "from": 1990,
          "to": 1998,
          "parent": "E36"
        },
        {
          "code": "E36/5",
          "model": { "en": "3 Series Compact", "de": "3er Compact" },
          "from": 1994,
          "to": 2000
        },
        {
          "code": "E36/7",
          "model": { "en": "Z3 Roadster", "de": "Z3 Roadster" },
          "from": 1995,
          "to": 2002
        },
        {
          "code": "E36/8",
          "model": { "en": "Z3 Coupé", "de": "Z3 Coupé" },
          "from": 1998,
          "to": 2002
        },
        { "code": "E38", "model": { "en": "7 Series", "de": "7er" }, "from": 1994, "to": 2001 },
        { "code": "E39", "model": { "en": "5 Series", "de": "5er" }, "from": 1995, "to": 2004 },
        {
          "code": "E46",
          "model": { "en": "3 Series (all bodies)", "de": "3er (alle Karosserien)" },
          "from": 1998,
          "to": 2006
        },
        {
          "code": "E46/2",
          "model": { "en": "3 Series Coupé", "de": "3er Coupé" },
          "from": 1999,
          "to": 2006,
          "parent": "E46"
        },
        {
          "code": "E46/2C",
          "model": { "en": "3 Series Convertible", "de": "3er Cabrio" },
          "from": 2000,
          "to": 2006,
          "parent": "E46"
        },
        {
          "code": "E46/3",
          "model": { "en": "3 Series Touring", "de": "3er Touring" },
          "from": 1999,
          "to": 2005,
          "parent": "E46"
        },
        {
          "code": "E46/4",
          "model": { "en": "3 Series Saloon", "de": "3er Limousine" },
          "from": 1998,
          "to": 2005,
          "parent": "E46"
        },
        {
          "code": "E46/5",
          "model": { "en": "3 Series Compact", "de": "3er Compact" },
          "from": 2001,
          "to": 2004
        },
        { "code": "E52", "model": { "en": "Z8", "de": "Z8" }, "from": 2000, "to": 2003 },
        { "code": "E53", "model": { "en": "X5", "de": "X5" }, "from": 1999, "to": 2006 },
        {
          "code": "E60",
          "model": { "en": "5 Series Saloon", "de": "5er Limousine" },
          "from": 2003,
          "to": 2010
        },
        {
          "code": "E61",
          "model": { "en": "5 Series Touring", "de": "5er Touring" },
          "from": 2004,
          "to": 2010
        },
        {
          "code": "E63",
          "model": { "en": "6 Series Coupé", "de": "6er Coupé" },
          "from": 2003,
          "to": 2010
        },
        {
          "code": "E64",
          "model": { "en": "6 Series Convertible", "de": "6er Cabrio" },
          "from": 2004,
          "to": 2010
        },
        { "code": "E65", "model": { "en": "7 Series", "de": "7er" }, "from": 2001, "to": 2008 },
        {
          "code": "E66",
          "model": { "en": "7 Series long wheelbase", "de": "7er Langversion" },
          "from": 2001,
          "to": 2008
        },
        { "code": "E70", "model": { "en": "X5", "de": "X5" }, "from": 2006, "to": 2013 },
        { "code": "E71", "model": { "en": "X6", "de": "X6" }, "from": 2008, "to": 2014 },
        {
          "code": "E81",
          "model": { "en": "1 Series 3-door", "de": "1er Dreitürer" },
          "from": 2007,
          "to": 2011
        },
        {
          "code": "E82",
          "model": { "en": "1 Series Coupé", "de": "1er Coupé" },
          "from": 2007,
          "to": 2013
        },
        { "code": "E83", "model": { "en": "X3", "de": "X3" }, "from": 2003, "to": 2010 },
        { "code": "E84", "model": { "en": "X1", "de": "X1" }, "from": 2009, "to": 2015 },
        {
          "code": "E85",
          "model": { "en": "Z4 Roadster", "de": "Z4 Roadster" },
          "from": 2002,
          "to": 2008
        },
        {
          "code": "E86",
          "model": { "en": "Z4 Coupé", "de": "Z4 Coupé" },
          "from": 2006,
          "to": 2008
        },
        {
          "code": "E87",
          "model": { "en": "1 Series 5-door", "de": "1er Fünftürer" },
          "from": 2004,
          "to": 2011
        },
        {
          "code": "E88",
          "model": { "en": "1 Series Convertible", "de": "1er Cabrio" },
          "from": 2008,
          "to": 2013
        },
        {
          "code": "E89",
          "model": { "en": "Z4 Roadster", "de": "Z4 Roadster" },
          "from": 2009,
          "to": 2016
        },
        {
          "code": "E90",
          "model": { "en": "3 Series Saloon", "de": "3er Limousine" },
          "from": 2005,
          "to": 2012
        },
        {
          "code": "E91",
          "model": { "en": "3 Series Touring", "de": "3er Touring" },
          "from": 2005,
          "to": 2012
        },
        {
          "code": "E92",
          "model": { "en": "3 Series Coupé", "de": "3er Coupé" },
          "from": 2006,
          "to": 2013
        },
        {
          "code": "E93",
          "model": { "en": "3 Series Convertible", "de": "3er Cabrio" },
          "from": 2007,
          "to": 2013
        },
        { "code": "F01", "model": { "en": "7 Series", "de": "7er" }, "from": 2008, "to": 2015 },
        {
          "code": "F02",
          "model": { "en": "7 Series long wheelbase", "de": "7er Langversion" },
          "from": 2008,
          "to": 2015
        },
        {
          "code": "F06",
          "model": { "en": "6 Series Gran Coupé", "de": "6er Gran Coupé" },
          "from": 2012,
          "to": 2018
        },
        {
          "code": "F07",
          "model": { "en": "5 Series Gran Turismo", "de": "5er Gran Turismo" },
          "from": 2009,
          "to": 2017
        },
        {
          "code": "F10",
          "model": { "en": "5 Series Saloon", "de": "5er Limousine" },
          "from": 2010,
          "to": 2017
        },
        {
          "code": "F11",
          "model": { "en": "5 Series Touring", "de": "5er Touring" },
          "from": 2010,
          "to": 2017
        },
        {
          "code": "F12",
          "model": { "en": "6 Series Convertible", "de": "6er Cabrio" },
          "from": 2011,
          "to": 2018
        },
        {
          "code": "F13",
          "model": { "en": "6 Series Coupé", "de": "6er Coupé" },
          "from": 2011,
          "to": 2017
        },
        { "code": "F15", "model": { "en": "X5", "de": "X5" }, "from": 2013, "to": 2018 },
        { "code": "F16", "model": { "en": "X6", "de": "X6" }, "from": 2014, "to": 2019 },
        {
          "code": "F20",
          "model": { "en": "1 Series 5-door", "de": "1er Fünftürer" },
          "from": 2011,
          "to": 2019
        },
        {
          "code": "F21",
          "model": { "en": "1 Series 3-door", "de": "1er Dreitürer" },
          "from": 2012,
          "to": 2019
        },
        {
          "code": "F22",
          "model": { "en": "2 Series Coupé", "de": "2er Coupé" },
          "from": 2014,
          "to": 2021
        },
        {
          "code": "F23",
          "model": { "en": "2 Series Convertible", "de": "2er Cabrio" },
          "from": 2015,
          "to": 2021
        },
        { "code": "F25", "model": { "en": "X3", "de": "X3" }, "from": 2010, "to": 2017 },
        { "code": "F26", "model": { "en": "X4", "de": "X4" }, "from": 2014, "to": 2018 },
        {
          "code": "F30",
          "model": { "en": "3 Series Saloon", "de": "3er Limousine" },
          "from": 2012,
          "to": 2019
        },
        {
          "code": "F31",
          "model": { "en": "3 Series Touring", "de": "3er Touring" },
          "from": 2012,
          "to": 2019
        },
        {
          "code": "F32",
          "model": { "en": "4 Series Coupé", "de": "4er Coupé" },
          "from": 2013,
          "to": 2020
        },
        {
          "code": "F33",
          "model": { "en": "4 Series Convertible", "de": "4er Cabrio" },
          "from": 2014,
          "to": 2020
        },
        {
          "code": "F34",
          "model": { "en": "3 Series Gran Turismo", "de": "3er Gran Turismo" },
          "from": 2013,
          "to": 2020
        },
        {
          "code": "F36",
          "model": { "en": "4 Series Gran Coupé", "de": "4er Gran Coupé" },
          "from": 2014,
          "to": 2020
        },
        { "code": "F39", "model": { "en": "X2", "de": "X2" }, "from": 2018, "to": 2023 },
        { "code": "F40", "model": { "en": "1 Series", "de": "1er" }, "from": 2019, "to": 2024 },
        {
          "code": "F44",
          "model": { "en": "2 Series Gran Coupé", "de": "2er Gran Coupé" },
          "from": 2020,
          "to": 2024
        },
        {
          "code": "F45",
          "model": { "en": "2 Series Active Tourer", "de": "2er Active Tourer" },
          "from": 2014,
          "to": 2021
        },
        {
          "code": "F46",
          "model": { "en": "2 Series Gran Tourer", "de": "2er Gran Tourer" },
          "from": 2015,
          "to": 2022
        },
        { "code": "F48", "model": { "en": "X1", "de": "X1" }, "from": 2015, "to": 2022 },
        { "code": "F70", "model": { "en": "1 Series", "de": "1er" }, "from": 2024, "to": null },
        {
          "code": "F74",
          "model": { "en": "2 Series Gran Coupé", "de": "2er Gran Coupé" },
          "from": 2024,
          "to": null
        },
        { "code": "G01", "model": { "en": "X3", "de": "X3" }, "from": 2017, "to": 2024 },
        { "code": "G02", "model": { "en": "X4", "de": "X4" }, "from": 2018, "to": 2025 },
        { "code": "G05", "model": { "en": "X5", "de": "X5" }, "from": 2018, "to": 2026 },
        { "code": "G06", "model": { "en": "X6", "de": "X6" }, "from": 2019, "to": null },
        { "code": "G07", "model": { "en": "X7", "de": "X7" }, "from": 2018, "to": null },
        { "code": "G08", "model": { "en": "iX3", "de": "iX3" }, "from": 2020, "to": 2025 },
        { "code": "G11", "model": { "en": "7 Series", "de": "7er" }, "from": 2015, "to": 2022 },
        {
          "code": "G12",
          "model": { "en": "7 Series long wheelbase", "de": "7er Langversion" },
          "from": 2015,
          "to": 2022
        },
        {
          "code": "G14",
          "model": { "en": "8 Series Convertible", "de": "8er Cabrio" },
          "from": 2018,
          "to": 2026
        },
        {
          "code": "G15",
          "model": { "en": "8 Series Coupé", "de": "8er Coupé" },
          "from": 2018,
          "to": 2026
        },
        {
          "code": "G16",
          "model": { "en": "8 Series Gran Coupé", "de": "8er Gran Coupé" },
          "from": 2019,
          "to": 2026
        },
        {
          "code": "G20",
          "model": { "en": "3 Series Saloon", "de": "3er Limousine" },
          "from": 2019,
          "to": 2026
        },
        {
          "code": "G21",
          "model": { "en": "3 Series Touring", "de": "3er Touring" },
          "from": 2019,
          "to": null
        },
        {
          "code": "G22",
          "model": { "en": "4 Series Coupé", "de": "4er Coupé" },
          "from": 2020,
          "to": null
        },
        {
          "code": "G23",
          "model": { "en": "4 Series Convertible", "de": "4er Cabrio" },
          "from": 2021,
          "to": null
        },
        {
          "code": "G26",
          "model": { "en": "4 Series Gran Coupé", "de": "4er Gran Coupé" },
          "from": 2021,
          "to": null
        },
        { "code": "G26 (i4)", "model": { "en": "i4", "de": "i4" }, "from": 2021, "to": null },
        {
          "code": "G29",
          "model": { "en": "Z4 Roadster", "de": "Z4 Roadster" },
          "from": 2018,
          "to": 2026
        },
        {
          "code": "G30",
          "model": { "en": "5 Series Saloon", "de": "5er Limousine" },
          "from": 2017,
          "to": 2023
        },
        {
          "code": "G31",
          "model": { "en": "5 Series Touring", "de": "5er Touring" },
          "from": 2017,
          "to": 2024
        },
        {
          "code": "G32",
          "model": { "en": "6 Series Gran Turismo", "de": "6er Gran Turismo" },
          "from": 2017,
          "to": 2023
        },
        {
          "code": "G42",
          "model": { "en": "2 Series Coupé", "de": "2er Coupé" },
          "from": 2021,
          "to": null
        },
        { "code": "G45", "model": { "en": "X3", "de": "X3" }, "from": 2024, "to": null },
        {
          "code": "G50",
          "model": { "en": "3 Series Saloon", "de": "3er Limousine" },
          "from": 2026,
          "to": null
        },
        {
          "code": "G60",
          "model": { "en": "5 Series Saloon", "de": "5er Limousine" },
          "from": 2023,
          "to": null
        },
        {
          "code": "G60 (i5)",
          "model": { "en": "i5 Saloon", "de": "i5 Limousine" },
          "from": 2023,
          "to": null
        },
        {
          "code": "G61",
          "model": { "en": "5 Series Touring", "de": "5er Touring" },
          "from": 2024,
          "to": null
        },
        {
          "code": "G61 (i5)",
          "model": { "en": "i5 Touring", "de": "i5 Touring" },
          "from": 2024,
          "to": null
        },
        { "code": "G65", "model": { "en": "X5", "de": "X5" }, "from": 2026, "to": null },
        { "code": "G70", "model": { "en": "7 Series", "de": "7er" }, "from": 2022, "to": null },
        { "code": "G70 (i7)", "model": { "en": "i7", "de": "i7" }, "from": 2022, "to": null },
        { "code": "I01", "model": { "en": "i3", "de": "i3" }, "from": 2013, "to": 2022 },
        {
          "code": "I12",
          "model": { "en": "i8 Coupé", "de": "i8 Coupé" },
          "from": 2014,
          "to": 2020
        },
        {
          "code": "I15",
          "model": { "en": "i8 Roadster", "de": "i8 Roadster" },
          "from": 2018,
          "to": 2020
        },
        { "code": "I20", "model": { "en": "iX", "de": "iX" }, "from": 2021, "to": null },
        {
          "code": "NA0",
          "model": { "en": "i3 (Neue Klasse)", "de": "i3 (Neue Klasse)" },
          "from": 2026,
          "to": null
        },
        {
          "code": "NA5",
          "model": { "en": "iX3 (Neue Klasse)", "de": "iX3 (Neue Klasse)" },
          "from": 2025,
          "to": null
        },
        {
          "code": "U06",
          "model": { "en": "2 Series Active Tourer", "de": "2er Active Tourer" },
          "from": 2021,
          "to": null
        },
        { "code": "U10", "model": { "en": "X2", "de": "X2" }, "from": 2023, "to": null },
        { "code": "U10 (iX2)", "model": { "en": "iX2", "de": "iX2" }, "from": 2023, "to": null },
        { "code": "U11", "model": { "en": "X1", "de": "X1" }, "from": 2022, "to": null },
        { "code": "U11 (iX1)", "model": { "en": "iX1", "de": "iX1" }, "from": 2022, "to": null }
      ]
    },
    {
      "id": "bmw_m",
      "aliases": true,
      "entries": [
        { "code": "E26", "model": { "en": "M1", "de": "M1" }, "from": 1978, "to": 1981 },
        {
          "code": "E24 (M6)",
          "model": { "en": "M635 CSi, M6", "de": "M635 CSi, M6" },
          "from": 1984,
          "to": 1989
        },
        { "code": "E28S (M5)", "model": { "en": "M5", "de": "M5" }, "from": 1985, "to": 1988 },
        {
          "code": "E30 (M3)",
          "model": { "en": "M3 (all bodies)", "de": "M3 (alle Karosserien)" },
          "from": 1986,
          "to": 1991
        },
        {
          "code": "E30/2S (M3)",
          "model": { "en": "M3", "de": "M3" },
          "from": 1986,
          "to": 1990,
          "parent": "E30 (M3)"
        },
        {
          "code": "E30/2SC (M3)",
          "model": { "en": "M3 Convertible", "de": "M3 Cabrio" },
          "from": 1988,
          "to": 1991,
          "parent": "E30 (M3)"
        },
        { "code": "E34 (M5)", "model": { "en": "M5", "de": "M5" }, "from": 1988, "to": 1995 },
        {
          "code": "E36 (M3)",
          "model": { "en": "M3 (all bodies)", "de": "M3 (alle Karosserien)" },
          "from": 1992,
          "to": 1999
        },
        {
          "code": "E36/2S (M3)",
          "model": { "en": "M3 Coupé", "de": "M3 Coupé" },
          "from": 1992,
          "to": 1999,
          "parent": "E36 (M3)"
        },
        {
          "code": "E36/2CS (M3)",
          "model": { "en": "M3 Convertible", "de": "M3 Cabrio" },
          "from": 1994,
          "to": 1999,
          "parent": "E36 (M3)"
        },
        {
          "code": "E36/4S (M3)",
          "model": { "en": "M3 Saloon", "de": "M3 Limousine" },
          "from": 1994,
          "to": 1998,
          "parent": "E36 (M3)"
        },
        {
          "code": "E36/7 (Z3 M)",
          "model": { "en": "Z3 M Roadster", "de": "Z3 M Roadster" },
          "from": 1996,
          "to": 2002
        },
        {
          "code": "E36/8 (Z3 M)",
          "model": { "en": "Z3 M Coupé", "de": "Z3 M Coupé" },
          "from": 1998,
          "to": 2002
        },
        { "code": "E39S (M5)", "model": { "en": "M5", "de": "M5" }, "from": 1998, "to": 2003 },
        { "code": "E46 (M3)", "model": { "en": "M3", "de": "M3" }, "from": 2000, "to": 2006 },
        {
          "code": "E60 (M5)",
          "model": { "en": "M5 Saloon", "de": "M5 Limousine" },
          "from": 2005,
          "to": 2010
        },
        {
          "code": "E61 (M5)",
          "model": { "en": "M5 Touring", "de": "M5 Touring" },
          "from": 2007,
          "to": 2010
        },
        {
          "code": "E63 (M6)",
          "model": { "en": "M6 Coupé", "de": "M6 Coupé" },
          "from": 2005,
          "to": 2010
        },
        {
          "code": "E64 (M6)",
          "model": { "en": "M6 Convertible", "de": "M6 Cabrio" },
          "from": 2006,
          "to": 2010
        },
        { "code": "E70 (X5 M)", "model": { "en": "X5 M", "de": "X5 M" }, "from": 2009, "to": 2013 },
        { "code": "E71 (X6 M)", "model": { "en": "X6 M", "de": "X6 M" }, "from": 2009, "to": 2014 },
        {
          "code": "E82 (1M)",
          "model": { "en": "1 Series M Coupé", "de": "1er M Coupé" },
          "from": 2011,
          "to": 2012
        },
        {
          "code": "E85 (Z4 M)",
          "model": { "en": "Z4 M Roadster", "de": "Z4 M Roadster" },
          "from": 2006,
          "to": 2008
        },
        {
          "code": "E86 (Z4 M)",
          "model": { "en": "Z4 M Coupé", "de": "Z4 M Coupé" },
          "from": 2006,
          "to": 2008
        },
        {
          "code": "E90 (M3)",
          "model": { "en": "M3 Saloon", "de": "M3 Limousine" },
          "from": 2007,
          "to": 2011
        },
        {
          "code": "E92 (M3)",
          "model": { "en": "M3 Coupé", "de": "M3 Coupé" },
          "from": 2007,
          "to": 2013
        },
        {
          "code": "E93 (M3)",
          "model": { "en": "M3 Convertible", "de": "M3 Cabrio" },
          "from": 2008,
          "to": 2013
        },
        {
          "code": "F06 (M6)",
          "model": { "en": "M6 Gran Coupé", "de": "M6 Gran Coupé" },
          "from": 2013,
          "to": 2018
        },
        { "code": "F10 (M5)", "model": { "en": "M5", "de": "M5" }, "from": 2011, "to": 2016 },
        {
          "code": "F12 (M6)",
          "model": { "en": "M6 Convertible", "de": "M6 Cabrio" },
          "from": 2012,
          "to": 2018
        },
        {
          "code": "F13 (M6)",
          "model": { "en": "M6 Coupé", "de": "M6 Coupé" },
          "from": 2012,
          "to": 2017
        },
        { "code": "F80", "model": { "en": "M3", "de": "M3" }, "from": 2014, "to": 2018 },
        {
          "code": "F82",
          "model": { "en": "M4 Coupé", "de": "M4 Coupé" },
          "from": 2014,
          "to": 2020
        },
        {
          "code": "F83",
          "model": { "en": "M4 Convertible", "de": "M4 Cabrio" },
          "from": 2014,
          "to": 2020
        },
        { "code": "F85", "model": { "en": "X5 M", "de": "X5 M" }, "from": 2014, "to": 2018 },
        { "code": "F86", "model": { "en": "X6 M", "de": "X6 M" }, "from": 2014, "to": 2019 },
        { "code": "F87", "model": { "en": "M2", "de": "M2" }, "from": 2015, "to": 2021 },
        { "code": "F90", "model": { "en": "M5", "de": "M5" }, "from": 2017, "to": 2023 },
        {
          "code": "F91",
          "model": { "en": "M8 Convertible", "de": "M8 Cabrio" },
          "from": 2019,
          "to": 2025
        },
        {
          "code": "F92",
          "model": { "en": "M8 Coupé", "de": "M8 Coupé" },
          "from": 2019,
          "to": 2025
        },
        {
          "code": "F93",
          "model": { "en": "M8 Gran Coupé", "de": "M8 Gran Coupé" },
          "from": 2019,
          "to": 2025
        },
        { "code": "F95", "model": { "en": "X5 M", "de": "X5 M" }, "from": 2020, "to": null },
        { "code": "F96", "model": { "en": "X6 M", "de": "X6 M" }, "from": 2020, "to": null },
        { "code": "F97", "model": { "en": "X3 M", "de": "X3 M" }, "from": 2019, "to": 2024 },
        { "code": "F98", "model": { "en": "X4 M", "de": "X4 M" }, "from": 2019, "to": 2025 },
        { "code": "G09", "model": { "en": "XM", "de": "XM" }, "from": 2022, "to": null },
        {
          "code": "G80",
          "model": { "en": "M3 Saloon", "de": "M3 Limousine" },
          "from": 2021,
          "to": null
        },
        {
          "code": "G81",
          "model": { "en": "M3 Touring", "de": "M3 Touring" },
          "from": 2022,
          "to": null
        },
        {
          "code": "G82",
          "model": { "en": "M4 Coupé", "de": "M4 Coupé" },
          "from": 2021,
          "to": null
        },
        {
          "code": "G83",
          "model": { "en": "M4 Convertible", "de": "M4 Cabrio" },
          "from": 2021,
          "to": null
        },
        { "code": "G87", "model": { "en": "M2", "de": "M2" }, "from": 2023, "to": null },
        {
          "code": "G90",
          "model": { "en": "M5 Saloon", "de": "M5 Limousine" },
          "from": 2024,
          "to": null
        },
        {
          "code": "G99",
          "model": { "en": "M5 Touring", "de": "M5 Touring" },
          "from": 2024,
          "to": null
        }
      ]
    },
    {
      "id": "mini",
      "aliases": true,
      "entries": [
        {
          "code": "R50",
          "model": { "en": "One, Cooper (3-door)", "de": "One, Cooper (3-Türer)" },
          "from": 2001,
          "to": 2006
        },
        {
          "code": "R52",
          "model": { "en": "Convertible", "de": "Cabrio" },
          "from": 2004,
          "to": 2008
        },
        {
          "code": "R53",
          "model": { "en": "Cooper S (3-door)", "de": "Cooper S (3-Türer)" },
          "from": 2001,
          "to": 2006
        },
        { "code": "R55", "model": { "en": "Clubman", "de": "Clubman" }, "from": 2007, "to": 2014 },
        { "code": "R56", "model": { "en": "3-door", "de": "3-Türer" }, "from": 2006, "to": 2014 },
        {
          "code": "R57",
          "model": { "en": "Convertible", "de": "Cabrio" },
          "from": 2008,
          "to": 2015
        },
        { "code": "R58", "model": { "en": "Coupé", "de": "Coupé" }, "from": 2011, "to": 2015 },
        {
          "code": "R59",
          "model": { "en": "Roadster", "de": "Roadster" },
          "from": 2011,
          "to": 2015
        },
        {
          "code": "R60",
          "model": { "en": "Countryman", "de": "Countryman" },
          "from": 2010,
          "to": 2016
        },
        { "code": "R61", "model": { "en": "Paceman", "de": "Paceman" }, "from": 2012, "to": 2016 },
        { "code": "F54", "model": { "en": "Clubman", "de": "Clubman" }, "from": 2015, "to": 2024 },
        { "code": "F55", "model": { "en": "5-door", "de": "5-Türer" }, "from": 2014, "to": 2024 },
        { "code": "F56", "model": { "en": "3-door", "de": "3-Türer" }, "from": 2014, "to": 2024 },
        {
          "code": "F57",
          "model": { "en": "Convertible", "de": "Cabrio" },
          "from": 2016,
          "to": 2024
        },
        {
          "code": "F60",
          "model": { "en": "Countryman", "de": "Countryman" },
          "from": 2016,
          "to": 2024
        },
        {
          "code": "F65",
          "model": { "en": "Cooper 5-door", "de": "Cooper 5-Türer" },
          "from": 2024,
          "to": null
        },
        {
          "code": "F66",
          "model": { "en": "Cooper 3-door", "de": "Cooper 3-Türer" },
          "from": 2024,
          "to": null
        },
        {
          "code": "F67",
          "model": { "en": "Cooper Convertible", "de": "Cooper Cabrio" },
          "from": 2024,
          "to": null
        },
        {
          "code": "J01",
          "model": { "en": "Cooper Electric (3-door)", "de": "Cooper Electric (3-Türer)" },
          "from": 2024,
          "to": null
        },
        { "code": "J05", "model": { "en": "Aceman", "de": "Aceman" }, "from": 2024, "to": null },
        {
          "code": "U25",
          "model": { "en": "Countryman", "de": "Countryman" },
          "from": 2024,
          "to": null
        }
      ]
    },
    {
      "id": "motorrad",
      "aliases": true,
      "entries": [
        {
          "code": "R13 (F650GS)",
          "model": { "en": "F 650 GS (single)", "de": "F 650 GS (Einzylinder)" },
          "from": 2000,
          "to": 2007
        },
        {
          "code": "R13 (G650GS)",
          "model": { "en": "G 650 GS", "de": "G 650 GS" },
          "from": 2009,
          "to": 2015
        },
        {
          "code": "R21 (R1150GS)",
          "model": { "en": "R 1150 GS", "de": "R 1150 GS" },
          "from": 1999,
          "to": 2004
        },
        {
          "code": "R21 (R1150GSA)",
          "model": { "en": "R 1150 GS Adventure", "de": "R 1150 GS Adventure" },
          "from": 2001,
          "to": 2005
        },
        {
          "code": "K02",
          "model": { "en": "G 310 GS", "de": "G 310 GS" },
          "from": 2017,
          "to": null
        },
        { "code": "K03", "model": { "en": "G 310 R", "de": "G 310 R" }, "from": 2016, "to": null },
        {
          "code": "K08",
          "model": { "en": "C 400 GT", "de": "C 400 GT" },
          "from": 2019,
          "to": null
        },
        { "code": "K09", "model": { "en": "C 400 X", "de": "C 400 X" }, "from": 2018, "to": null },
        {
          "code": "K17",
          "model": { "en": "C evolution", "de": "C evolution" },
          "from": 2014,
          "to": 2021
        },
        {
          "code": "K18 (C600Sport)",
          "model": { "en": "C 600 Sport", "de": "C 600 Sport" },
          "from": 2012,
          "to": 2015
        },
        {
          "code": "K18 (C650Sport)",
          "model": { "en": "C 650 Sport", "de": "C 650 Sport" },
          "from": 2015,
          "to": 2020
        },
        {
          "code": "K19",
          "model": { "en": "C 650 GT", "de": "C 650 GT" },
          "from": 2012,
          "to": 2020
        },
        { "code": "K21", "model": { "en": "R nineT", "de": "R nineT" }, "from": 2014, "to": 2024 },
        {
          "code": "K22",
          "model": { "en": "R nineT Pure", "de": "R nineT Pure" },
          "from": 2017,
          "to": 2024
        },
        {
          "code": "K23",
          "model": { "en": "R nineT Scrambler", "de": "R nineT Scrambler" },
          "from": 2016,
          "to": 2024
        },
        {
          "code": "K25 (R1200GS)",
          "model": { "en": "R 1200 GS", "de": "R 1200 GS" },
          "from": 2004,
          "to": 2012
        },
        {
          "code": "K25 (HP2Enduro)",
          "model": { "en": "HP2 Enduro", "de": "HP2 Enduro" },
          "from": 2005,
          "to": 2008
        },
        {
          "code": "K25 (HP2Megamoto)",
          "model": { "en": "HP2 Megamoto", "de": "HP2 Megamoto" },
          "from": 2007,
          "to": 2010
        },
        {
          "code": "K255",
          "model": { "en": "R 1200 GS Adventure", "de": "R 1200 GS Adventure" },
          "from": 2005,
          "to": 2013
        },
        {
          "code": "K26 (R1200RT)",
          "model": { "en": "R 1200 RT", "de": "R 1200 RT" },
          "from": 2005,
          "to": 2013
        },
        {
          "code": "K26 (R900RT)",
          "model": { "en": "R 900 RT", "de": "R 900 RT" },
          "from": 2005,
          "to": 2013
        },
        {
          "code": "K27",
          "model": { "en": "R 1200 R", "de": "R 1200 R" },
          "from": 2006,
          "to": 2014
        },
        {
          "code": "K28",
          "model": { "en": "R 1200 ST", "de": "R 1200 ST" },
          "from": 2005,
          "to": 2007
        },
        {
          "code": "K29 (R1200S)",
          "model": { "en": "R 1200 S", "de": "R 1200 S" },
          "from": 2006,
          "to": 2008
        },
        {
          "code": "K29 (HP2Sport)",
          "model": { "en": "HP2 Sport", "de": "HP2 Sport" },
          "from": 2008,
          "to": 2010
        },
        {
          "code": "K32",
          "model": { "en": "R nineT Racer", "de": "R nineT Racer" },
          "from": 2017,
          "to": 2019
        },
        {
          "code": "K33",
          "model": { "en": "R nineT Urban G/S", "de": "R nineT Urban G/S" },
          "from": 2017,
          "to": 2023
        },
        { "code": "K34", "model": { "en": "R 18", "de": "R 18" }, "from": 2020, "to": null },
        {
          "code": "K40 (K1200S)",
          "model": { "en": "K 1200 S", "de": "K 1200 S" },
          "from": 2004,
          "to": 2008
        },
        {
          "code": "K40 (K1300S)",
          "model": { "en": "K 1300 S", "de": "K 1300 S" },
          "from": 2009,
          "to": 2015
        },
        {
          "code": "K41 (K1200RS)",
          "model": { "en": "K 1200 RS", "de": "K 1200 RS" },
          "from": 1996,
          "to": 2005
        },
        {
          "code": "K41 (K1200GT)",
          "model": { "en": "K 1200 GT", "de": "K 1200 GT" },
          "from": 2002,
          "to": 2005
        },
        {
          "code": "K43 (K1200R)",
          "model": { "en": "K 1200 R", "de": "K 1200 R" },
          "from": 2005,
          "to": 2008
        },
        {
          "code": "K43 (K1300R)",
          "model": { "en": "K 1300 R", "de": "K 1300 R" },
          "from": 2009,
          "to": 2015
        },
        {
          "code": "K44 (K1200GT)",
          "model": { "en": "K 1200 GT", "de": "K 1200 GT" },
          "from": 2006,
          "to": 2008
        },
        {
          "code": "K44 (K1300GT)",
          "model": { "en": "K 1300 GT", "de": "K 1300 GT" },
          "from": 2009,
          "to": 2011
        },
        {
          "code": "K46 (S1000RR)",
          "model": { "en": "S 1000 RR", "de": "S 1000 RR" },
          "from": 2009,
          "to": 2018
        },
        { "code": "K46 (HP4)", "model": { "en": "HP4", "de": "HP4" }, "from": 2012, "to": 2014 },
        {
          "code": "K47",
          "model": { "en": "S 1000 R", "de": "S 1000 R" },
          "from": 2014,
          "to": 2020
        },
        {
          "code": "K48 (K1600GT)",
          "model": { "en": "K 1600 GT", "de": "K 1600 GT" },
          "from": 2011,
          "to": null
        },
        {
          "code": "K48 (K1600GTL)",
          "model": { "en": "K 1600 GTL", "de": "K 1600 GTL" },
          "from": 2011,
          "to": null
        },
        {
          "code": "K49",
          "model": { "en": "S 1000 XR", "de": "S 1000 XR" },
          "from": 2015,
          "to": 2019
        },
        {
          "code": "K50 (R1200GS)",
          "model": { "en": "R 1200 GS", "de": "R 1200 GS" },
          "from": 2013,
          "to": 2018
        },
        {
          "code": "K50 (R1250GS)",
          "model": { "en": "R 1250 GS", "de": "R 1250 GS" },
          "from": 2019,
          "to": 2023
        },
        {
          "code": "K51 (R1200GSA)",
          "model": { "en": "R 1200 GS Adventure", "de": "R 1200 GS Adventure" },
          "from": 2014,
          "to": 2018
        },
        {
          "code": "K51 (R1250GSA)",
          "model": { "en": "R 1250 GS Adventure", "de": "R 1250 GS Adventure" },
          "from": 2019,
          "to": 2023
        },
        {
          "code": "K52 (R1200RT)",
          "model": { "en": "R 1200 RT", "de": "R 1200 RT" },
          "from": 2014,
          "to": 2018
        },
        {
          "code": "K52 (R1250RT)",
          "model": { "en": "R 1250 RT", "de": "R 1250 RT" },
          "from": 2019,
          "to": 2024
        },
        {
          "code": "K53 (R1200R)",
          "model": { "en": "R 1200 R", "de": "R 1200 R" },
          "from": 2015,
          "to": 2018
        },
        {
          "code": "K53 (R1250R)",
          "model": { "en": "R 1250 R", "de": "R 1250 R" },
          "from": 2019,
          "to": 2023
        },
        {
          "code": "K54 (R1200RS)",
          "model": { "en": "R 1200 RS", "de": "R 1200 RS" },
          "from": 2015,
          "to": 2018
        },
        {
          "code": "K54 (R1250RS)",
          "model": { "en": "R 1250 RS", "de": "R 1250 RS" },
          "from": 2019,
          "to": 2023
        },
        {
          "code": "K60",
          "model": { "en": "HP4 Race", "de": "HP4 Race" },
          "from": 2017,
          "to": 2017
        },
        {
          "code": "K63",
          "model": { "en": "S 1000 R", "de": "S 1000 R" },
          "from": 2021,
          "to": null
        },
        {
          "code": "K67",
          "model": { "en": "S 1000 RR", "de": "S 1000 RR" },
          "from": 2019,
          "to": null
        },
        {
          "code": "K69",
          "model": { "en": "S 1000 XR", "de": "S 1000 XR" },
          "from": 2020,
          "to": null
        },
        {
          "code": "K70",
          "model": { "en": "F 700 GS", "de": "F 700 GS" },
          "from": 2012,
          "to": 2018
        },
        {
          "code": "K71 (F800S)",
          "model": { "en": "F 800 S", "de": "F 800 S" },
          "from": 2006,
          "to": 2010
        },
        {
          "code": "K71 (F800ST)",
          "model": { "en": "F 800 ST", "de": "F 800 ST" },
          "from": 2006,
          "to": 2012
        },
        {
          "code": "K71 (F800GT)",
          "model": { "en": "F 800 GT", "de": "F 800 GT" },
          "from": 2013,
          "to": 2019
        },
        {
          "code": "K72 (F650GS)",
          "model": { "en": "F 650 GS (twin)", "de": "F 650 GS (Zweizylinder)" },
          "from": 2008,
          "to": 2012
        },
        {
          "code": "K72 (F800GS)",
          "model": { "en": "F 800 GS", "de": "F 800 GS" },
          "from": 2008,
          "to": 2018
        },
        { "code": "K73", "model": { "en": "F 800 R", "de": "F 800 R" }, "from": 2009, "to": 2019 },
        {
          "code": "K80 (F750GS)",
          "model": { "en": "F 750 GS", "de": "F 750 GS" },
          "from": 2018,
          "to": 2023
        },
        {
          "code": "K80 (F800GS)",
          "model": { "en": "F 800 GS", "de": "F 800 GS" },
          "from": 2024,
          "to": null
        },
        {
          "code": "K81",
          "model": { "en": "F 850 GS", "de": "F 850 GS" },
          "from": 2018,
          "to": 2023
        },
        {
          "code": "K82 (F850GSA)",
          "model": { "en": "F 850 GS Adventure", "de": "F 850 GS Adventure" },
          "from": 2019,
          "to": 2023
        },
        {
          "code": "K82 (F900GSA)",
          "model": { "en": "F 900 GS Adventure", "de": "F 900 GS Adventure" },
          "from": 2024,
          "to": null
        },
        {
          "code": "KA1",
          "model": { "en": "R 1300 GS", "de": "R 1300 GS" },
          "from": 2023,
          "to": null
        }
      ]
    }
  ]
}
